var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPostsIconSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Driving_Licence",
    "data-name": "Driving Licence",
    d: "M20,0H4A4,4,0,0,0,0,4V20a4,4,0,0,0,4,4H20a4,4,0,0,0,4-4V4a4,4,0,0,0-4-4M4,6A2.006,2.006,0,0,1,6,4H9a2,2,0,0,1,2,2v5a1.993,1.993,0,0,1-2,2H6a2,2,0,0,1-2-2ZM18.5,20.02H5.5a1.5,1.5,0,0,1,0-3h13a1.5,1.5,0,0,1,0,3m0-7.05h-4a1.5,1.5,0,0,1,0-3h4a1.5,1.5,0,0,1,0,3m0-6h-4a1.5,1.5,0,1,1,0-3h4a1.5,1.5,0,1,1,0,3",
    fill: "#E65847"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostsIconSelected);
export default __webpack_public_path__ + "static/media/PostsIconSelected.33efbcf1d2ef5b6c86f736aeee224950.svg";
export { ForwardRef as ReactComponent };